module.exports = "<mapping-filters></mapping-filters>\n<mapping-instructions></mapping-instructions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/importclient/import-client.component.html
// module id = 2137
// module chunks = 0